module.exports = __webpack_public_path__ + "static/media/miami.f56ada30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/miami.png
// module id = 1176
// module chunks = 0